// Central content + imagery for MD Labs

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1743046813915-94cf6d5e6942?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  cleanroomMask:
    "https://images.unsplash.com/photo-1668511237401-4c71e8df5a17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gloves:
    "https://images.unsplash.com/photo-1668600418844-5b3d2e381e10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  twoPeopleTablet:
    "https://images.unsplash.com/photo-1669101283561-642d16d924ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  whiteSuit:
    "https://images.unsplash.com/photo-1748349221526-33b51820b21e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  microscope:
    "https://images.unsplash.com/photo-1582719471384-894fbb16e074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  labTube:
    "https://images.unsplash.com/photo-1579165466991-467135ad3110?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  equipment:
    "https://images.unsplash.com/photo-1569852573858-03c9e2877792?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  microscopeWhite:
    "https://images.unsplash.com/photo-1518152006812-edab29b069ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Quality & Compliance", to: "/quality" },
  { label: "Private Label", to: "/private-label" },
  { label: "Contact", to: "/contact" },
];

export const DIFFERENTIATORS = [
  {
    no: "01",
    title: "FDA 510(k) Cleared",
    body: "A cleared medical device manufacturer operating under strict federal quality and regulatory standards.",
    icon: "ShieldCheck",
  },
  {
    no: "02",
    title: "ISO 7 Certified Cleanroom",
    body: "Certified to ISO 14644-1:2015 — both Ante Room (ISO 8) and Clean Room (ISO 7) environments.",
    icon: "Wind",
  },
  {
    no: "03",
    title: "Private Label Capabilities",
    body: "Concept to finished, labeled product for wellness brands, physicians and healthcare companies.",
    icon: "Layers",
  },
  {
    no: "04",
    title: "Full Documentation Package",
    body: "Certificate of Analysis, Safety Data Sheets and ISO cleanroom certification available.",
    icon: "FileCheck2",
  },
];

export const AUDIENCES = [
  {
    title: "Wellness Brands",
    body: "Entrepreneurs and established brands ready to private label suppositories under their own name.",
    img: IMAGES.twoPeopleTablet,
  },
  {
    title: "Physicians & Providers",
    body: "Healthcare providers seeking custom formulations built from client-specified ingredients.",
    img: IMAGES.microscope,
  },
  {
    title: "Healthcare Companies",
    body: "Organizations that need a compliant, documented manufacturing partner they can trust.",
    img: IMAGES.whiteSuit,
  },
];

export const CAPABILITIES = [
  {
    no: "01",
    title: "Cleanroom Manufacturing",
    body: "Suppository manufacturing performed inside a certified ISO 7 cleanroom environment, controlled for particulates and contamination.",
  },
  {
    no: "02",
    title: "Private Label",
    body: "Third-party manufacturing that lets your brand offer finished, labeled products without operating a facility.",
  },
  {
    no: "03",
    title: "Custom Formulation",
    body: "Formulations built to your specification using client-specified ingredients and target profiles.",
  },
  {
    no: "04",
    title: "Documentation Package",
    body: "Certificate of Analysis (CoA), Safety Data Sheets and ISO cleanroom certification supplied with your production.",
  },
  {
    no: "05",
    title: "Scalable Batch Sizes",
    body: "Production that scales with growing brands — from initial runs to sustained volume.",
  },
  {
    no: "06",
    title: "Concept to Finished Product",
    body: "End-to-end support taking a brand from an idea to a finished, labeled, market-ready product.",
  },
];

export const PROCESS = [
  { no: "01", title: "Inquiry", body: "You reach out with your product vision, target formulation and volume expectations." },
  { no: "02", title: "Consultation", body: "We align on ingredients, specifications, regulatory scope and timelines." },
  { no: "03", title: "Documentation Review", body: "CoA, SDS and cleanroom certification are reviewed so everything is above board." },
  { no: "04", title: "Manufacturing", body: "Production runs in our certified ISO 7 cleanroom under cGMP-aligned processes." },
  { no: "05", title: "Delivery", body: "Finished, labeled product is delivered with its full documentation package." },
];

export const COMPLIANCE = [
  {
    tag: "Federal Clearance",
    title: "FDA 510(k) Medical Device Clearance",
    body: "MD Labs holds a 510(k) clearance from the FDA — a demonstration that our device is substantially equivalent to a legally marketed device and manufactured under regulated quality standards.",
  },
  {
    tag: "ISO 14644-1:2015",
    title: "ISO 7 Cleanroom Certification",
    body: "Our facility is certified for both the Ante Room (ISO 8) and Clean Room (ISO 7) by Clean Room Services of Canoga Park, CA — validating strict control of airborne particulates.",
  },
  {
    tag: "cGMP Aligned",
    title: "Current Good Manufacturing Practice",
    body: "Manufacturing processes are aligned to cGMP principles, ensuring consistency, traceability and quality at every stage of production.",
  },
  {
    tag: "Traceability",
    title: "Full Chain of Custody",
    body: "Complete chain of custody documentation is available, giving partners and regulators confidence that everything is documented and verifiable.",
  },
];
